import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { formatManwon } from '../../../utils/formatKRW';
import { TaxBenefitYearDataPoint } from '../TaxBenefitPage.hooks';

export interface TaxBenefitChartProps {
  yearlyData: TaxBenefitYearDataPoint[];
}

export function TaxBenefitChart({ yearlyData }: TaxBenefitChartProps) {
  return (
    <ResponsiveContainer width="100%" height={240}>
      <BarChart data={yearlyData} margin={{ top: 8, right: 8, bottom: 0, left: 8 }}>
        <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f0f0f0" />
        <XAxis dataKey="year" tickFormatter={(v) => `${v}년`} axisLine={false} tickLine={false} />
        <YAxis tickFormatter={(v) => `${Math.round(v / 10000)}만`} width={64} axisLine={false} tickLine={false} />
        <Tooltip
          formatter={((v: number, name: string) => [formatManwon(v), name]) as any}
          labelFormatter={(v) => `${v}년차`}
        />
        <Legend />
        <Bar dataKey="irpCumulative" name="IRP 세액공제 누적" fill="#3b82f6" stackId="a" />
        <Bar dataKey="isaCumulative" name="ISA 절세 누적" fill="#10b981" stackId="a" radius={[4, 4, 0, 0]} />
      </BarChart>
    </ResponsiveContainer>
  );
}
